<template>
  <div class="tracking-products-recommendation">
    <h2 class="products-recommendation-title text--center mt-lg">
      You may also like
    </h2>
    <ProductListSlider
      :products="products?.length ? products : placeholderProducts"
    />
  </div>
</template>

<script lang="ts" setup>
import ProductListSlider from '@/components/product/ProductListSlider.vue'
import { Product } from '@/types'

withDefaults(
  defineProps<{
    products: Product[] | []
  }>(),
  {}
)
const placeholderProducts = Array(10).fill(undefined)
</script>
